var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box" },
    [
      _c(
        "div",
        { staticClass: "month-selector" },
        _vm._l(_vm.dateMenu, function(date) {
          return _c("div", { key: date.month }, [
            _c(
              "div",
              {
                staticClass: "month",
                class: [
                  { selected: date.monthName == _vm.selectedMonth.monthName },
                  { unselected: date.monthName != _vm.selectedMonth.monthName },
                  {
                    hover:
                      date.monthName == _vm.hoverMonth &&
                      date.monthName != _vm.selectedMonth.monthName
                  }
                ],
                on: {
                  click: function($event) {
                    return _vm.changeSelectedMonth(date)
                  },
                  mouseover: function($event) {
                    _vm.hoverMonth = date.monthName
                  },
                  mouseout: function($event) {
                    _vm.hoverMonth = null
                  }
                }
              },
              [_vm._v("\n        " + _vm._s(date.monthName) + "\n      ")]
            )
          ])
        }),
        0
      ),
      _vm._v(" "),
      _vm.loading
        ? _c("vue-loading", {
            attrs: {
              active: _vm.loading,
              "is-full-page": true,
              loader: "dots",
              color: "#70A1F0"
            },
            on: {
              "update:active": function($event) {
                _vm.loading = $event
              }
            }
          })
        : _c("div", { staticClass: "zendesk-page" }, [
            _c(
              "div",
              { staticClass: "zendesk-summary" },
              [
                _c("div", { staticClass: "zendesk-download" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-primary",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.downloadCSV("summary")
                        }
                      }
                    },
                    [_vm._v("Download Report")]
                  )
                ]),
                _vm._v(" "),
                _c("vue-good-table", {
                  attrs: {
                    columns: _vm.summaryCols,
                    rows: _vm.summary,
                    "search-options": {
                      enabled: true,
                      skipDiacritics: true,
                      placeholder: "filter"
                    },
                    styleClass: "vgt-table condensed"
                  },
                  on: { "on-row-dblclick": _vm.changeContract }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "zendesk-tickets" },
              [
                _c("div", { staticClass: "zendesk-download" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-primary",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.downloadCSV("tickets")
                        }
                      }
                    },
                    [_vm._v("Download Report")]
                  )
                ]),
                _vm._v(" "),
                _c("vue-good-table", {
                  attrs: {
                    columns: _vm.ticketsCols,
                    rows: _vm.tickets,
                    "search-options": {
                      enabled: true,
                      skipDiacritics: true,
                      placeholder: "filter"
                    },
                    styleClass: "vgt-table condensed"
                  },
                  on: { "on-row-dblclick": _vm.openTicket }
                })
              ],
              1
            )
          ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-08daa404", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08daa404","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ZendeskSummary.vue
// module id = null
// module chunks = 